import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LayoutItemProps } from "apis/layout";
import { PaginationProps } from "utils/types/API";

export interface LayoutState {
    loading: boolean;
    list: {
        data: LayoutItemProps[];
        options: LayoutItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: LayoutItemProps;
    };
}

const initialState: LayoutState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: LayoutItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: LayoutItemProps;
}
export const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = layoutSlice.actions;
export default layoutSlice.reducer;
